import React, { useState, useRef, useCallback, useEffect } from 'react';
import PeopleModalStyled from './PeopleModalStyled';
import {
  Box,
  IconButton,
  // InputLabel,
  useTheme,
  FormControl,
  Input,
  InputAdornment,
  Button,
} from '@material-ui/core';
import { useIntl } from 'umi';
import SearchIcon from '@material-ui/icons/Search';
import DataTableNativeML from '@/components/DataTableNativeML';
import {
  // Controller,
  useForm,
} from 'react-hook-form';
import request from '@/utils/request';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const [title, setTitle] = useState();
  const storesNameRef = useRef('');
  const {
    // handleSubmit,
    control,
    // reset,
    // errors,
    // setValue,
    // register,
  } = useForm({});

  const theme = useTheme();
  const { userGroup, onConfirm, setOpen } = props;

  const onHandleClickSearchStores = () => {
    setTitle(storesNameRef.current);
  };

  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });

  // const [title, setTitle] = useState();
  // const [couponId, setCouponId] = useState([]);
  // 存储选中的数据
  const [chooseUserGroup, setChooseUserGroup] = useState(userGroup);
  const [userGroupData, setUserGroupData] = useState({
    userGroupList: [],
    total: 0,
  });
  const fetchCouponList = useCallback(() => {
    request('/profile/queryGroupPage', {
      method: 'POST',
      data: {
        title: title,
        pageNum: pageData.pageNum,
        pageSize: pageData.pageSize,
      },
    })
      .then((res) => {
        if (res.code === 0) {
          setUserGroupData({
            userGroupList: res.data.data,
            total: res.data.total,
          });
        }
      })
      .catch((err) => console.log(err));
  }, [pageData, title]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };
  const handleClose = () => {
    setOpen(false);
  };

  // const handleSubmitSuccess = () => {
  //   // setOpen(false);
  // };

  const onSubmitUserGroupData = () => {
    onConfirm(chooseUserGroup);
    setOpen(false);
  };

  // const [orderObj] = useState({
  //   grade: 'asc',
  //   availablePoint: 'asc',
  //   signUpDate: 'asc',
  // });

  const columns = [
    {
      type: 'checkbox',
      align: 'right',
      width: 32,
      onChange: (newSelected) => {
        setChooseUserGroup(newSelected);
      },
    },
    {
      title: formatMessage({ id: 'marketing.people.custom.d01.lbl03' }),
      align: 'center',
      id: 'title',
      key: 'title',
    },
    {
      title: formatMessage({ id: 'marketing.people.custom.d01.lbl04' }),
      align: 'center',
      id: 'quantity',
      key: 'quantity',
    },
  ];

  return (
    <PeopleModalStyled theme={theme}>
      <Box width="261px" ml={3} className="coupon-name-wrap" mb={2}>
        <FormControl
          sx={{ m: 1, width: '100%' }}
          variant="standard"
          className="coupon-name"
        >
          {/* <InputLabel htmlFor="standard-adornment-password">
            请输入人群名称
          </InputLabel> */}
          <Input
            id="standard-adornment-password"
            type="text"
            placeholder={formatMessage({
              id: 'marketing.people.custom.d01.placeholder02',
            })}
            // "请输入人群名称"
            defaultValue={storesNameRef.current}
            ref={storesNameRef}
            onChange={(e) => {
              storesNameRef.current = e.target.value;
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={onHandleClickSearchStores}
                  // onMouseDown={handleMouseDownPassword}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Box>
      <DataTableNativeML
        singleSelect
        columns={columns}
        chooseIds={chooseUserGroup}
        changePage={changePage}
        page={pageData}
        data={userGroupData.userGroupList}
        columnKey="id"
        total={userGroupData.total}
        paging={true}
        devicesMinWidth="auto"
        control={control}
      ></DataTableNativeML>
      <div className="modal-btn-wrap">
        <Button onClick={handleClose} variant="contained" color="secondary">
          {formatMessage({ id: 'comm.action.btn.08' })}
        </Button>
        <Button
          variant="contained"
          type="submit"
          className="btnSubmit button"
          onClick={onSubmitUserGroupData}
        >
          {formatMessage({ id: 'comm.action.btn.07' })}
        </Button>
      </div>
    </PeopleModalStyled>
  );
};
